<template>
    <div v-if="show">
        <card-quiz
                v-if="currentCard"
                :card="currentCard"
                :stack="stack"
                :quiz-level="level"
                :card-count="cardCount"
                :card-number="cardNumber"
                @done="nextCard()"
                @finished="finished()"
        />
    </div>
    <v-container v-else>
        <h2 class="text-center">
            {{ $t('nav.loading') }}
        </h2>
    </v-container>
</template>

<script>
    import CardQuiz from "@/components/cards/CardQuiz";
    import GetUrl from "@/components/mixins/GetUrl";
    import LoginRedirect from "@/components/mixins/LoginRedirect";
    import {CardList} from "../../models/Card";
    import {Stack} from "@/models/Stack";
    export default {
        name: "StackQuiz",
        components: {CardQuiz},
        mixins: [GetUrl, LoginRedirect],
        props: {
            cardsetId: {
                required: true,
                type: Number,
            },
            stackId: {
                required: true,
                type: Number
            },
            level: {
                required: true,
                type: Number,
                default: -1,
            },
        },
        data: function () {
            return {
                currentCard: null,
                position: 0,
                show: false,
                cards: new CardList(),
                stack: new Stack(),
            }
        },
        methods: {
            nextCard: function () {
                if (this.position < this.cards.list.length) {
                    this.currentCard = this.cards.list[this.position];
                    this.position += 1;
                } else {
                    this.finished();
                }
            },
            finished: function () {
                if (this.level === 3) {
                    this.$router.push({
                        name: 'cardset-detail',
                        params: {
                            pk: this.cardsetId,
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'stack-drill',
                        params: {
                            pk: this.stack.id,
                            cardsetId: this.cardsetId,
                        }
                    })
                }
            }
        },
        computed: {
            cardCount () {
                return this.cards.list.length;
            },
            cardNumber () {
                return this.position;
            },
        },
        mounted: function () {
            // eslint-disable-next-line no-console
            // console.log(this.cardsetId)
            // this.getStack();
            let that = this;
            this.stack.api.fetch(this.stackId).then(function () {
                that.stack.api.fetchQuizList(that.level).then(function () {
                    that.cards = that.stack.api.quizCards;
                    that.show = true;
                    that.position = 0;
                    that.nextCard();
                });
            });
            this.position = 0;
            // this.show = true;
        },
    }
</script>

<style scoped>

</style>
